// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customize-env-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.customize-env-header p {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #616161;
  cursor: pointer;
}
.customize-env-header p svg {
  width: 0.7em;
}

.customize-env-body {
  margin: 3vw 0 0 1.83vw;
  background-color: rgba(255, 255, 255, 0.8980392157);
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
  backdrop-filter: blur(42px);
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431) inset;
}
.customize-env-body .tabs {
  border-bottom: 1px solid #dcdcdc;
}
.customize-env-body .tabs ul {
  justify-content: flex-start;
}
.customize-env-body .tabs ul li {
  color: #3a3a3a;
  font-size: 1vw;
  font-weight: 500;
  padding: 1vw 1.5vw;
  margin: 0.25vw 1vw;
  cursor: pointer;
}
.customize-env-body .tabs ul li.active {
  color: #ee3a24;
  position: relative;
}
.customize-env-body .tabs ul li.active::after {
  content: "";
  width: calc(100% - 2.5vw);
  position: absolute;
  background: #ee3a24;
  height: 1px;
  bottom: 0.5vw;
  left: 50%;
  transform: translateX(-50%);
}
.customize-env-body .main-container-body {
  padding: 1.5vw 1.5vw 2vw;
  display: flex;
  gap: 1vw;
}
.customize-env-body .main-container-body .cust-title {
  color: #3a3a3a;
  font-weight: 500;
  font-size: 1.05vw;
  line-height: 1.05vw;
  margin-bottom: 1vw;
}
.customize-env-body .main-container-body .dropbox-title {
  color: #ee3a24;
  font-weight: 500;
  font-size: 1.05vw;
  line-height: 1.05vw;
}
.customize-env-body .main-container-body .custom-drag-box {
  border: 1px dashed #ababab;
  background-color: #fafafa;
  border-radius: 10px;
  padding: 10px;
  position: relative;
  cursor: pointer;
  margin-top: 10px;
}
.customize-env-body .main-container-body .custom-drag-box:hover {
  background-color: #e6e6e6;
}
.customize-env-body .main-container-body .custom-drag-box .custom-drag-input {
  position: absolute;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.customize-env-body .main-container-body .custom-drag-box .custom-drag-box-title {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: center;
  color: #7d7d7d;
}
.customize-env-body .main-container-body .custom-drag-box .custom-drag-box-subTitle {
  font-size: 12px;
  letter-spacing: 0em;
  text-align: center;
  color: #3a3a3a;
  margin-top: 5px;
}
.customize-env-body .main-container-body .customize-data {
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.customize-env-body .main-container-body .customize-data .enviromentName {
  border: 1px solid #737373;
  border-radius: 3px;
  background-color: rgba(217, 217, 217, 0);
  width: 100%;
  padding: 0.75vw;
  box-sizing: border-box;
  margin-bottom: 1vw;
  color: #3a3a3a;
}
.customize-env-body .main-container-body .customize-data .buttons {
  display: flex;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
}
.customize-env-body .main-container-body .customize-data .buttons button {
  background-color: transparent;
  border-radius: 4px;
  min-height: 25px;
  min-width: 100px;
  padding: 6px 10px;
  text-align: center;
  border: 1px solid #ee3a24;
  color: #ee3a24;
  outline: none;
  width: 50%;
  cursor: pointer;
  line-height: 25px;
}
.customize-env-body .main-container-body .customize-data .buttons button:last-child {
  background-color: #ee3a24;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.customize-env-body .main-container-body .customize-data .buttons button:last-child svg {
  width: 0.7em;
}
.customize-env-body .main-container-body .customize-body {
  width: 60%;
}
.customize-env-body .main-container-body .productCustomizationBar-reload {
  right: 30px;
}`, "",{"version":3,"sources":["webpack://./src/style/components/store/CustomizeEnv.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAEJ;AADI;EACE,YAAA;AAGN;;AACA;EACE,sBAAA;EACA,mDAAA;EACA,6GAAA;EAKA,2BAAA;EACA,uEAAA;AAFF;AAGE;EACE,gCAAA;AADJ;AAEI;EACE,2BAAA;AAAN;AACM;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AACR;AAAQ;EACE,cAAA;EACA,kBAAA;AAEV;AADU;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;AAGZ;AAGE;EACE,wBAAA;EACA,aAAA;EACA,QAAA;AADJ;AAEI;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAAN;AAEI;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAAN;AAEI;EACE,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAAN;AACM;EACE,yBAAA;AACR;AACM;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AACR;AACM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACR;AACM;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AACR;AAEI;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAAN;AACM;EACE,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AACR;AACM;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AACR;AAAQ;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAEV;AADU;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAGZ;AAFY;EACE,YAAA;AAId;AAEI;EACE,UAAA;AAAN;AAEI;EACE,WAAA;AAAN","sourcesContent":[".customize-env-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  p {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    color: #616161;\n    cursor: pointer;\n    svg {\n      width: 0.7em;\n    }\n  }\n}\n.customize-env-body {\n  margin: 3vw 0 0 1.83vw;\n  background-color: #ffffffe5;\n  border-image-source: linear-gradient(\n    169.15deg,\n    rgba(255, 255, 255, 0.4) 0%,\n    rgba(238, 237, 237, 0.2) 96.79%\n  );\n  backdrop-filter: blur(42px);\n  box-shadow: -5px -5px 250px 0px #ffffff05 inset;\n  .tabs {\n    border-bottom: 1px solid #dcdcdc;\n    ul {\n      justify-content: flex-start;\n      li {\n        color: #3a3a3a;\n        font-size: 1vw;\n        font-weight: 500;\n        padding: 1vw 1.5vw;\n        margin: 0.25vw 1vw;\n        cursor: pointer;\n        &.active {\n          color: #ee3a24;\n          position: relative;\n          &::after {\n            content: \"\";\n            width: calc(100% - 2.5vw);\n            position: absolute;\n            background: #ee3a24;\n            height: 1px;\n            bottom: 0.5vw;\n            left: 50%;\n            transform: translateX(-50%);\n          }\n        }\n      }\n    }\n  }\n  .main-container-body {\n    padding: 1.5vw 1.5vw 2vw;\n    display: flex;\n    gap: 1vw;\n    .cust-title {\n      color: #3a3a3a;\n      font-weight: 500;\n      font-size: 1.05vw;\n      line-height: 1.05vw;\n      margin-bottom: 1vw;\n    }\n    .dropbox-title {\n      color: #ee3a24;\n      font-weight: 500;\n      font-size: 1.05vw;\n      line-height: 1.05vw;\n    }\n    .custom-drag-box {\n      border: 1px dashed #ababab;\n      background-color: #fafafa;\n      border-radius: 10px;\n      padding: 10px;\n      position: relative;\n      cursor: pointer;\n      margin-top: 10px;\n      &:hover {\n        background-color: #e6e6e6;\n      }\n      .custom-drag-input {\n        position: absolute;\n        display: none;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n      }\n      .custom-drag-box-title {\n        font-family: Inter;\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 15px;\n        letter-spacing: 0em;\n        text-align: center;\n        color: #7d7d7d;\n      }\n      .custom-drag-box-subTitle {\n        font-size: 12px;\n        letter-spacing: 0em;\n        text-align: center;\n        color: #3a3a3a;\n        margin-top: 5px;\n      }\n    }\n    .customize-data {\n      width: 40%;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      .enviromentName {\n        border: 1px solid #737373;\n        border-radius: 3px;\n        background-color: #d9d9d900;\n        width: 100%;\n        padding: 0.75vw;\n        box-sizing: border-box;\n        margin-bottom: 1vw;\n        color: #3a3a3a;\n      }\n      .buttons {\n        display: flex;\n        align-items: center;\n        margin-top: 10px;\n        gap: 10px;\n        button {\n          background-color: transparent;\n          border-radius: 4px;\n          min-height: 25px;\n          min-width: 100px;\n          padding: 6px 10px;\n          text-align: center;\n          border: 1px solid #ee3a24;\n          color: #ee3a24;\n          outline: none;\n          width: 50%;\n          cursor: pointer;\n          line-height: 25px;\n          &:last-child {\n            background-color: #ee3a24;\n            color: #fff;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 5px;\n            svg {\n              width: 0.7em;\n            }\n          }\n        }\n      }\n    }\n    .customize-body {\n      width: 60%;\n    }\n    .productCustomizationBar-reload {\n      right: 30px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
